<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <VisitTracker />
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useUserStore } from './stores/user'
import { useSiteConfigStore } from './stores/siteConfig'
import VisitTracker from './components/VisitTracker.vue'

const userStore = useUserStore()
const siteConfigStore = useSiteConfigStore()

onMounted(async () => {
  await Promise.all([
    userStore.restoreAuth(),
    siteConfigStore.fetchConfig()
  ])
})
</script>